import React, { useEffect } from 'react';
import './Notification.css';

const Notification = ({ notification, onClose }) => {
  useEffect(() => {
    if (notification.duration) {
      const timer = setTimeout(() => {
        onClose(notification.id);
      }, notification.duration);
      return () => clearTimeout(timer);
    }
  }, [notification, onClose]);

  const getIcon = () => {
    switch (notification.type) {
      case 'success':
        return '✓';
      case 'error':
        return '✕';
      case 'warning':
        return '⚠';
      case 'info':
        return 'ℹ';
      default:
        return 'ℹ';
    }
  };

  return (
    <div className={`notification notification-${notification.type} notification-enter`}>
      <div className="notification-icon">{getIcon()}</div>
      <div className="notification-content">
        {notification.title && <div className="notification-title">{notification.title}</div>}
        <div className="notification-message">{notification.message}</div>
      </div>
      <button className="notification-close" onClick={() => onClose(notification.id)}>
        ×
      </button>
    </div>
  );
};

export default Notification;
